import React from 'react'
import { Link } from 'react-router'
import { Container, Grid, Span } from 'react-responsive-grid'
import { prefixLink } from 'gatsby-helpers'
import includes from 'underscore.string/include'
import { colors, activeColors } from 'utils/colors'

import typography from 'utils/typography'
import { config } from 'config'

// Import styles.
import 'css/main.css'
import 'css/github.css'

import SharingButtons from '../components/SharingButtons'
import Footer from '../components/Footer'

const { rhythm, adjustFontSizeTo } = typography

module.exports = React.createClass({
  propTypes() {
    return {
      children: React.PropTypes.object,
    }
  },
  render() {
    const maxWidth = 720

    return (
      <div>
        <div
          style={{
            background: colors.bg,
            color: colors.fg,
            marginBottom: rhythm(1.5),
          }}
        >
          <Container
            style={{
              maxWidth,
              paddingLeft: rhythm(3/4),
              paddingRight: rhythm(3/4),
            }}
          >
            <Grid
              columns={12}
              style={{
                padding: `${rhythm(3/4)} 0`,
              }}
            >
              <Span
                columns={12}
                style={{
                  height: 24, // Ugly hack. How better to constrain height of div?
                }}
              >
                <Link
                  to={prefixLink('/')}
                  style={{
                    textDecoration: 'none',
                    color: 'white',
                    fontSize: adjustFontSizeTo('30px').fontSize,
                  }}
                >
                  {config.siteTitle}
                </Link>
              </Span>
            </Grid>
          </Container>
        </div>
        <Container
          style={{
            maxWidth,
            padding: `${rhythm(1)} ${rhythm(3/4)}`,
            paddingTop: 0,
          }}
        >
          <SharingButtons />
          {this.props.children}
          <Footer />
        </Container>
      </div>
    )
  },
})



/** WEBPACK FOOTER **
 ** ./_template.jsx
 **/